import React from "react";
import { Switch } from "@blueprintjs/core";
export default function RestrictionSwitch({ value, onChange, ...other }) {
  return (
    <Switch
      {...other}
      alignIndicator="right"
      checked={value !== "restricted"}
      onChange={(e) => {
        const checked = e.target && e.target.checked;
        onChange(checked ? "allowed" : "restricted");
      }}
    />
  );
}
